export function ValidatorComposer(validators: PropertyDecorator[]): () => PropertyDecorator {
  return () => {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return (target: Object, propertyKey: string | symbol): void => {
      validators.forEach((validator) => validator(target, propertyKey))
    }
  }
}
